export function runToolbarCommand(itemId: string): void {
  if (!window.apm) {
    return;
  }

  switch (itemId) {
    case 'icon-validate':
      window.apm.postEventToCurrentView({ target: 'request-validate' });
      break;
    case 'icon-check-square':
      window.apm.postEventToCurrentView({
        target: 'request-application-validation'
      });
      break;
    case 'icon-download':
      window.apm.postEventToCurrentView({ target: 'request-download-json' });
      break;
    case 'icon-capture':
      window.apm.postEventToCurrentView({ target: 'request-download-image' });
      break;
    case 'icon-show-disabled':
      window.apm.openDisabledItemsWindow();
      break;
    case 'icon-redo':
      window.apm.postEventToCurrentView({ target: 'request-redo' });
      break;
    case 'icon-undo':
      window.apm.postEventToCurrentView({ target: 'request-undo' });
      break;
    case 'icon-copy':
      window.apm.postEventToCurrentView({ target: 'request-copy' });
      break;
    case 'icon-paste':
      window.apm.postEventToCurrentView({ target: 'request-paste' });
      break;
    case 'icon-delete':
      window.apm.postEventToCurrentView({ target: 'request-delete' });
      break;
    case 'icon-zoom-in':
      window.apm.postEventToCurrentView({ target: 'request-zoom-in' });
      break;
    case 'icon-zoom-out':
      window.apm.postEventToCurrentView({ target: 'request-zoom-out' });
      break;
    case 'icon-toggle-disabled-elements': {
      const appManager = window.apm;
      appManager.serialized.displayPrefs.hideDisabledElements = !appManager.serialized.displayPrefs.hideDisabledElements;
      appManager.setSerializedChanged();
      appManager.postEventToAllViews({ target: 'request-toggle-disabled-elements' });
      appManager.initDisplayPrefs();
      break;
    }
    case 'icon-center-canvas':
      window.apm.getCurrentDiagramWidget().setCanvasCenter();
      break;
  }
}
